import { useCallback } from "react";
import { getCustomElementColumnDetailList } from "../../api/WorkOrders";
import { useWorkOrderStore } from "../../store/wo-order";

export default function useGetCustomFields() {
  const setCustomFields = useWorkOrderStore(
    (state) => state.setWoCustomElementColumnDetail
  );
  const getCustomFields = useCallback(
    async (woNumber: string) => {
      const response = await getCustomElementColumnDetailList();
      if (!response.isError) {
        setCustomFields(woNumber, response.data);
      }
      return response;
    },
    [setCustomFields]
  );

  return { getCustomFields };
}
